// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27%23475569%27 viewBox=%270 0 256 256%27%3E%3Cpath d=%27M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-section {
  padding: 0;
  background: transparent;
  min-height: 500px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Заголовок с кнопками */
.reports-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
}

.reports-header-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

/* Статистика */
.reports-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.reports-stat-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.reports-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e1;
}

.reports-stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  flex-shrink: 0;
}

.reports-stat-icon img {
  width: 28px;
  height: 28px;
  filter: brightness(0) invert(1);
}

.reports-stat-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.reports-stat-info h3 {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: #002FA7;
  line-height: 1;
}

.reports-stat-info p {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

/* Быстрое создание отчетов */
.reports-quick-create {
  display: grid;
  gap: 20px;
  margin-bottom: 8px;
}

.reports-quick-create.two-columns {
  grid-template-columns: repeat(2, 1fr);
}

.report-type-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: all 0.3s ease;
}

.report-type-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e1;
}

.report-type-card-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  display: flex;
  align-items: center;
  gap: 16px;
}

.report-type-icon-wrap {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.report-type-img {
  width: 34px;
  height: 34px;
  filter: brightness(0) invert(1);
}

.report-type-titles h4 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 700;
  color: white;
}

.report-type-titles p {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
  color: white;
  font-weight: 500;
}

.report-type-card-body {
  padding: 20px 24px;
}

.report-type-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.reports-btn-text {
  padding: 10px 16px;
  background: transparent;
  border: none;
  color: #002FA7;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
}

.reports-btn-text:hover {
  background: #f0f4ff;
  color: #002FA7;
}

.students-list-btn {
  background: #f0f4ff !important;
  color: #002FA7 !important;
}

.students-list-btn:hover {
  background: #e0e8ff !important;
}

/* Панель управления */
.reports-control-panel {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.reports-controls-top-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: center;
}

.reports-search-box {
  position: relative;
  flex: 1 1;
}

.reports-search-input {
  width: 100%;
  padding: 14px 20px 14px 48px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
  font-weight: 500;
}

.reports-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.reports-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.reports-search-icon img {
  width: 100%;
  height: 100%;
  opacity: 0.6;
}

.reports-search-clear {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #999;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  border-radius: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.reports-search-clear:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #002FA7;
}

.reports-controls-middle-row {
  width: 100%;
}

.reports-filters-grid {
  display: grid;
  grid-template-columns: minmax(200px, 1fr);
  gap: 20px;
  align-items: start;
}

.reports-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reports-filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.reports-filter-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  font-size: 14px;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding-right: 44px;
}

.reports-filter-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.reports-controls-bottom-row {
  width: 100%;
  padding-top: 20px;
  border-top: 2px solid #f1f5f9;
}

.reports-sort-controls {
  width: 100%;
}

.reports-sort-group {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.reports-sort-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.reports-sort-select {
  min-width: 200px;
  max-width: 300px;
  padding: 10px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  font-size: 14px;
  color: #1e293b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  padding-right: 44px;
}

.reports-sort-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.reports-sort-order-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.reports-sort-order-btn:hover {
  background: #f8fafc;
  border-color: #002FA7;
  color: #002FA7;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.reports-sort-order-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  transition: transform 0.3s ease;
}

/* Недавние отчеты */
.recent-reports-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.recent-reports-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f1f5f9;
}

.recent-reports-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.reports-count {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64748b;
  background: #f8fafc;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
}

.reports-count img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  opacity: 0.7;
}

.reports-count strong {
  font-weight: 700;
  color: #002FA7;
}

/* Таблица отчетов */
.recent-reports-table-container {
  width: 100%;
  overflow-x: auto;
  border-radius: 12px;
  background: white;
  border: 1px solid #e2e8f0;
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  table-layout: auto;
}

.reports-table th {
  background: #f8fafc;
  color: #002c9c;
  font-size: 14px;
  font-weight: 600;
  padding: 16px 12px;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  height: 60px;
  vertical-align: middle;
}

.reports-name-column{
  text-align: left;
}

.reports-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  font-size: 14px;
  transition: all 0.3s ease;
  vertical-align: middle;
}

.reports-table tbody tr:hover {
  background-color: #f8fafc;
}

.reports-number-column {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  text-align: center;
}

.reports-number-cell {
  text-align: center;
  color: #64748b;
  font-weight: 500;
}

.reports-type-badge {
  display: inline-block;
  padding: 6px 14px;
  color: #002FA7;
  font-size: 13px;
  font-weight: 600;
  border-radius: 30px;
  white-space: nowrap;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.reports-actions-cell .reports-action-btn {
  display: inline-flex;
  margin: 0 4px;
}

.reports-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #475569;
  min-width: 70px;
}

.reports-table td.reports-actions-cell {
  white-space: nowrap;
  padding: 12px 8px;
}

.reports-action-btn.word-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
  background: #f0f4ff;
}

.reports-action-btn.delete-btn-reports:hover {
  border-color: #a70000;
  color: #a70000;
  background: #fff0f0;
}


.reports-empty-cell {
  text-align: center;
  padding: 40px !important;
  color: #64748b;
}

.reports-modal.confirm-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  max-width: 420px;
  width: 90%;
  animation: modalSlideIn 0.2s ease-out;
}

.certificate-actions-bar {
  display: flex;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.cert-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s ease;
  color: #475569;
  padding: 0;
  flex-shrink: 0;
}

.cert-action-btn.add {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  font-weight: 700;
  font-size: 18px;
}

.cert-action-btn.add:hover {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.cert-action-btn.download-all {
  width: auto;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  gap: 6px;
}

.cert-action-btn.download-all:hover {
  background: linear-gradient(135deg, #0020a7 0%, #4875e6 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
  color: white;
}

.cert-action-btn.download-all:active {
  transform: translateY(0);
}

.cert-files-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.cert-file-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #f1f5f9;
  border-radius: 6px;
  font-size: 11px;
  color: #1e293b;
  max-width: 160px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.cert-file-tag:hover {
  border-color: #cbd5e1;
  background: #e2e8f0;
}

.cert-file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.cert-file-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;
  transition: all 0.15s ease;
  vertical-align: middle;
}

.cert-file-remove:hover {
  background: #fee2e2;
  color: #dc2626;
}


.cert-upload-big {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 2px dashed #002FA7;
  background: #f0f4ff;
  color: #002FA7;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cert-upload-big:hover {
  background: #002FA7;
  color: white;
  border-style: solid;
}

.certificate-cell {
  min-width: 140px;
}

.certificate-fields {
  margin-bottom: 4px;
}

/* Модальные окна */
.reports-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  backdrop-filter: blur(4px);
  z-index: 998;
  animation: modalAppear 0.2s ease-out;
}

@keyframes modalAppear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.reports-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 550px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: modalSlideIn 0.2s ease-out;
  display: flex;
  flex-direction: column;
}

.reports-modal.create-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

.reports-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 12px 12px 0 0;
  color: white;
}

.reports-modal-header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.reports-modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.reports-modal-icon img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.reports-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: white;
}

.reports-modal-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  opacity: 0.9;
  color: white;
}

.reports-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: white;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.reports-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.reports-modal-content {
  padding: 24px;
  flex: 1 1;
}

.reports-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #f3f4f6;
  background: white;
  border-radius: 0 0 12px 12px;
}

/* Стили для модального окна со студентами */
.students-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 16px;
  width: 95%;
  max-width: 1300px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 999;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.2s ease-out;
}

.students-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border-radius: 16px 16px 0 0;
  flex-shrink: 0;
}

.students-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.students-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.students-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.students-modal-table-wrapper {
  flex: 1 1;
  overflow-x: auto;
  overflow-y: auto;
  padding: 20px 24px;
}

/* Таблица студентов - без горизонтального скролла */
.students-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}

.students-table th {
  background: #f8fafc;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: #002FA7;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  font-size: 12px;
}

.students-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  vertical-align: top;
  word-break: break-word;
}

/* Ширина колонок */
.disabled-table th:nth-child(1),
.disabled-table td:nth-child(1) { width: 40px; text-align: center; }
.disabled-table th:nth-child(2) { width: 12%; }
.disabled-table th:nth-child(3) { width: 7%; }
.disabled-table th:nth-child(4) { width: 15%; }
.disabled-table th:nth-child(5) { width: 18%; }
.disabled-table th:nth-child(6) { width: 10%; }
.disabled-table th:nth-child(7) { width: 10%; }
.disabled-table th:nth-child(8) { width: 8%; }
.disabled-table th:nth-child(9) { width: 12%; }
.disabled-table th:nth-child(10) { width: 8%; }

.orphan-table th:nth-child(1),
.orphan-table td:nth-child(1) { width: 40px; text-align: center; }
.orphan-table th:nth-child(2) { width: 10%; }
.orphan-table th:nth-child(3) { width: 6%; }
.orphan-table th:nth-child(4) { width: 12%; }
.orphan-table th:nth-child(5) { width: 7%; }
.orphan-table th:nth-child(6) { width: 12%; }
.orphan-table th:nth-child(7) { width: 12%; }
.orphan-table th:nth-child(8) { width: 15%; }
.orphan-table th:nth-child(9) { width: 12%; }
.orphan-table th:nth-child(10) { width: 8%; }

.students-table tbody tr:hover {
  background-color: #f8fafc;
}

.col-num {
  text-align: center;
  color: #64748b;
  font-weight: 500;
}

/* Редактируемые ячейки */
.cell-content {
  cursor: pointer;
  padding: 4px 4px;
  border-radius: 4px;
  transition: background-color 0.15s ease;
}

.cell-content:hover {
  background-color: #e0e8ff;
}

.edit-input {
  width: 100%;
  padding: 6px 8px;
  border: 2px solid #002FA7;
  border-radius: 6px;
  font-size: 12px;
  background: white;
  box-sizing: border-box;
}

.edit-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.certificate-textarea {
  resize: none;
  min-height: 40px;
  font-family: inherit;
}

.certificate-input-small {
  width: 80px;
  padding: 2px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 11px;
  margin: 2px 0;
}

.certificate-image-section {
  margin-top: 6px;
}

.certificate-upload-btn {
  padding: 4px 8px;
  background: #f0f4ff;
  border: 1px dashed #002FA7;
  border-radius: 6px;
  color: #002FA7;
  font-size: 10px;
  cursor: pointer;
}

.certificate-upload-btn:hover {
  background: #e0e8ff;
}

.certificate-preview {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.certificate-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.certificate-change-btn {
  padding: 3px 8px;
  background: #f1f5f9;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  cursor: pointer;
}

/* Формы */
.pc-form-group {
  margin-bottom: 20px;
}

.pc-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

.pc-input-enhanced {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
}

.pc-input-enhanced:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);
}

.reports-format-static {
  margin-top: 8px;
}

.reports-format-badge {
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  background: #f1f5f9;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

/* Кнопки */
.reports-btn-secondary {
  padding: 12px 24px;
  background: white;
  color: #374151;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.reports-btn-secondary:hover {
  border-color: #002FA7;
  color: #002FA7;
  background: #f8fafc;
}

.cell-stack { 
  display: flex; 
  flex-direction: 
  column; gap: 
  4px; 

}

.cell-line  { 
  color: #1e293b; 

}

.cell-phone { 
  color: #475569; 
  font-size: 13px; 
}

.reports-confirm-btn {
  padding: 12px 32px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.reports-confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.reports-confirm-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Инфо иконка */
.info-icon-btn {
  position: relative;
  display: inline-block;
}

.header-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.pc-refresh-btn {
  gap: 8px;
}

.pc-refresh-icon {
  width: 18px;
  height: 18px;
}

.info-tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 320px;
  z-index: 100;
  display: none;
}

.info-icon-btn:hover .info-tooltip {
  display: block;
}

/* Адаптивность */
@media (max-width: 1024px) {
  .reports-quick-create.two-columns {
    grid-template-columns: 1fr;
  }
  
  .reports-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .reports-stats-grid {
    grid-template-columns: 1fr;
  }
  
  .reports-modal {
    width: 95%;
  }
  
  .students-modal {
    width: 98%;
    max-height: 90vh;
  }
  
  .students-modal-header h3 {
    font-size: 14px;
  }
  
  .students-table {
    font-size: 11px;
  }
  
  .students-table th,
  .students-table td {
    padding: 6px;
  }
}

/* Модальное окно широкое */
.students-modal.wide-modal {
  width: 98%;
  max-width: 1600px;
}

/* Поиск в модальном окне */
.modal-search-box {
  position: relative;
  margin: 16px 24px 0 24px;
}

.modal-search-input {
  width: 100%;
  padding: 12px 20px 12px 44px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  box-sizing: border-box;
}

.modal-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.modal-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.modal-search-clear {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 16px;
  padding: 4px 6px;
  border-radius: 20px;
}

.modal-search-clear:hover {
  background: #f1f5f9;
  color: #002FA7;
}

/* Ширина колонок - узкий номер */
.disabled-table .col-num-header,
.orphan-table .col-num-header {
  width: 45px;
  text-align: center;
}

.disabled-table td.col-num,
.orphan-table td.col-num {
  width: 45px;
  text-align: center;
  color: #64748b;
  font-weight: 500;
}

/* Поле для справки - полная ширина */
.certificate-fields .edit-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 12px;
  background: white;
  box-sizing: border-box;
}

.certificate-fields .edit-input:focus {
  outline: none;
  border-color: #002FA7;
}

/* Превью фото справки */
.certificate-thumb {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: transform 0.2s;
}

.certificate-thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Пустая строка в таблице */
.empty-row {
  text-align: center;
  padding: 40px !important;
  color: #64748b;
}

/* Упрощенная секция отчетов */
.recent-reports-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f1f5f9;
}

.recent-reports-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 18px;
  font-weight: 600;
}

.reports-count {
  font-size: 14px;
  color: #64748b;
}

.reports-count strong {
  color: #002FA7;
}

/* Адаптация */
@media (max-width: 1200px) {
  .students-table {
    min-width: 1000px;
  }
}

@media (max-width: 768px) {
  .students-modal.wide-modal {
    width: 98%;
  }
  
  .modal-search-box {
    margin: 12px 16px 0 16px;
  }
  
  .certificate-fields .edit-input {
    font-size: 10px;
    padding: 6px 8px;
  }
  
  .image-preview-modal {
    width: 95%;
    padding: 12px;
  }
}

.reports-actions-cell {
  white-space: nowrap;
  width: 1%;
}

.disabled-table th:nth-child(10), 
.disabled-table td:nth-child(10) { 
  width: 10%; 
  min-width: 140px; 
}

.orphan-table th:nth-child(10),
.orphan-table td:nth-child(10) { 
  width: 10%; 
  min-width: 140px; 
}

/* Стили для валидации */
.edit-input.validation-error {
  border-color: rgb(102, 60, 25);
  background-color: #fef2f2;
}

.edit-input.validation-error:focus {
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  border-color: #b88441;
}

.validation-error-message {
  font-size: 11px;
  color: #b88441;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.validation-error-message::before {
  content: '⚠';
  font-size: 10px;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #64748b;
  font-size: 16px;
  font-weight: 500;
}

.loading-overlay::before {
  content: '';
  width: 24px;
  height: 24px;
  border: 3px solid #e2e8f0;
  border-top-color: #002FA7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 12px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Анимация обновления */
.pc-refreshing {
  opacity: 0.7;
  pointer-events: none;
}

.pc-refresh-spin {
  animation: spin 1s linear infinite;
}

/* Стили для загрузки сертификата */
.certificate-upload-btn {
  padding: 6px 12px;
  background: #f0f4ff;
  border: 1px dashed #002FA7;
  border-radius: 8px;
  color: #002FA7;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.certificate-upload-btn:hover {
  background: #e0e8ff;
  border-style: solid;
}

.certificate-change-btn {
  padding: 4px 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  color: #475569;
  transition: all 0.2s ease;
}

.certificate-change-btn:hover {
  background: #e2e8f0;
  color: #002FA7;
}

.certificate-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.certificate-thumb {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.certificate-thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Улучшенные стили для редактируемых ячеек */
.cell-content {
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
  transition: all 0.15s ease;
  min-height: 20px;
  line-height: 1.4;
}

.cell-content:hover {
  background-color: #e0e8ff;
  color: #002FA7;
}

.cell-content:empty::before {
  content: '—';
  color: #94a3b8;
}

.edit-input {
  width: 100%;
  padding: 6px 10px;
  border: 2px solid #002FA7;
  border-radius: 6px;
  font-size: 13px;
  background: white;
  box-sizing: border-box;
  font-family: inherit;
  line-height: 1.4;
}

.edit-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.certificate-textarea {
  resize: vertical;
  min-height: 60px;
  font-family: inherit;
}

/* Стили для пустых состояний */
.empty-row {
  text-align: center;
  padding: 40px !important;
  color: #64748b;
  font-size: 14px;
}

/* Адаптация модальных окон */
@media (max-width: 768px) {
  .students-modal.wide-modal {
    width: 98%;
    max-height: 90vh;
  }

  .students-modal-header h3 {
    font-size: 14px;
  }

  .students-table {
    font-size: 11px;
  }

  .students-table th,
  .students-table td {
    padding: 6px 4px;
  }

  .certificate-thumb {
    width: 40px;
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/social-components/SocialReportsSection.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,yDAA4S;EAC5S,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,yDAA4S;EAC5S,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,0BAA0B;EAC1B,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;kCACkC,WAAW,EAAE,kBAAkB,EAAE;AACnE,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,SAAS,EAAE;AAC7C,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,UAAU,EAAE;AAC9C,kCAAkC,SAAS,EAAE;AAC7C,kCAAkC,UAAU,EAAE;AAC9C,mCAAmC,SAAS,EAAE;;AAE9C;gCACgC,WAAW,EAAE,kBAAkB,EAAE;AACjE,gCAAgC,UAAU,EAAE;AAC5C,gCAAgC,SAAS,EAAE;AAC3C,gCAAgC,UAAU,EAAE;AAC5C,gCAAgC,SAAS,EAAE;AAC3C,gCAAgC,UAAU,EAAE;AAC5C,gCAAgC,UAAU,EAAE;AAC5C,gCAAgC,UAAU,EAAE;AAC5C,gCAAgC,UAAU,EAAE;AAC5C,iCAAiC,SAAS,EAAE;;AAE5C;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;QACM,EAAE;KACL;;AAEL;;AAEA;EACE,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".reports-section {\n  padding: 0;\n  background: transparent;\n  min-height: 500px;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Заголовок с кнопками */\n.reports-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.reports-header-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n/* Статистика */\n.reports-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.reports-stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.reports-stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  border-color: #cbd5e1;\n}\n\n.reports-stat-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  flex-shrink: 0;\n}\n\n.reports-stat-icon img {\n  width: 28px;\n  height: 28px;\n  filter: brightness(0) invert(1);\n}\n\n.reports-stat-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.reports-stat-info h3 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 800;\n  color: #002FA7;\n  line-height: 1;\n}\n\n.reports-stat-info p {\n  margin: 0;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Быстрое создание отчетов */\n.reports-quick-create {\n  display: grid;\n  gap: 20px;\n  margin-bottom: 8px;\n}\n\n.reports-quick-create.two-columns {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.report-type-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.report-type-card:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n  border-color: #cbd5e1;\n}\n\n.report-type-card-header {\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.report-type-icon-wrap {\n  width: 60px;\n  height: 60px;\n  border-radius: 14px;\n  overflow: hidden;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.report-type-img {\n  width: 34px;\n  height: 34px;\n  filter: brightness(0) invert(1);\n}\n\n.report-type-titles h4 {\n  margin: 0 0 4px 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n}\n\n.report-type-titles p {\n  margin: 0;\n  font-size: 13px;\n  opacity: 0.9;\n  color: white;\n  font-weight: 500;\n}\n\n.report-type-card-body {\n  padding: 20px 24px;\n}\n\n.report-type-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.reports-btn-text {\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 8px;\n}\n\n.reports-btn-text:hover {\n  background: #f0f4ff;\n  color: #002FA7;\n}\n\n.students-list-btn {\n  background: #f0f4ff !important;\n  color: #002FA7 !important;\n}\n\n.students-list-btn:hover {\n  background: #e0e8ff !important;\n}\n\n/* Панель управления */\n.reports-control-panel {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e2e8f0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.reports-controls-top-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n  align-items: center;\n}\n\n.reports-search-box {\n  position: relative;\n  flex: 1;\n}\n\n.reports-search-input {\n  width: 100%;\n  padding: 14px 20px 14px 48px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  background: white;\n  box-sizing: border-box;\n  font-weight: 500;\n}\n\n.reports-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.reports-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  pointer-events: none;\n}\n\n.reports-search-icon img {\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n}\n\n.reports-search-clear {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 30%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.reports-search-clear:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: #002FA7;\n}\n\n.reports-controls-middle-row {\n  width: 100%;\n}\n\n.reports-filters-grid {\n  display: grid;\n  grid-template-columns: minmax(200px, 1fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.reports-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.reports-filter-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.reports-filter-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  background: white;\n  font-size: 14px;\n  color: #1e293b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23475569' viewBox='0 0 256 256'%3E%3Cpath d='M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 16px;\n  padding-right: 44px;\n}\n\n.reports-filter-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.reports-controls-bottom-row {\n  width: 100%;\n  padding-top: 20px;\n  border-top: 2px solid #f1f5f9;\n}\n\n.reports-sort-controls {\n  width: 100%;\n}\n\n.reports-sort-group {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.reports-sort-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.reports-sort-select {\n  min-width: 200px;\n  max-width: 300px;\n  padding: 10px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  background: white;\n  font-size: 14px;\n  color: #1e293b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23475569' viewBox='0 0 256 256'%3E%3Cpath d='M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z'%3E%3C/path%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  background-size: 16px;\n  padding-right: 44px;\n}\n\n.reports-sort-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.reports-sort-order-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.reports-sort-order-btn:hover {\n  background: #f8fafc;\n  border-color: #002FA7;\n  color: #002FA7;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.reports-sort-order-icon {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  transition: transform 0.3s ease;\n}\n\n/* Недавние отчеты */\n.recent-reports-section {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e2e8f0;\n}\n\n.recent-reports-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.recent-reports-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.reports-count {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #64748b;\n  background: #f8fafc;\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.reports-count img {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  opacity: 0.7;\n}\n\n.reports-count strong {\n  font-weight: 700;\n  color: #002FA7;\n}\n\n/* Таблица отчетов */\n.recent-reports-table-container {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 12px;\n  background: white;\n  border: 1px solid #e2e8f0;\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  table-layout: auto;\n}\n\n.reports-table th {\n  background: #f8fafc;\n  color: #002c9c;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 16px 12px;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  height: 60px;\n  vertical-align: middle;\n}\n\n.reports-name-column{\n  text-align: left;\n}\n\n.reports-table td {\n  padding: 16px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  vertical-align: middle;\n}\n\n.reports-table tbody tr:hover {\n  background-color: #f8fafc;\n}\n\n.reports-number-column {\n  width: 50px;\n  min-width: 50px;\n  max-width: 50px;\n  text-align: center;\n}\n\n.reports-number-cell {\n  text-align: center;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.reports-type-badge {\n  display: inline-block;\n  padding: 6px 14px;\n  color: #002FA7;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 30px;\n  white-space: nowrap;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.reports-actions-cell .reports-action-btn {\n  display: inline-flex;\n  margin: 0 4px;\n}\n\n.reports-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #475569;\n  min-width: 70px;\n}\n\n.reports-table td.reports-actions-cell {\n  white-space: nowrap;\n  padding: 12px 8px;\n}\n\n.reports-action-btn.word-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n  background: #f0f4ff;\n}\n\n.reports-action-btn.delete-btn-reports:hover {\n  border-color: #a70000;\n  color: #a70000;\n  background: #fff0f0;\n}\n\n\n.reports-empty-cell {\n  text-align: center;\n  padding: 40px !important;\n  color: #64748b;\n}\n\n.reports-modal.confirm-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n  max-width: 420px;\n  width: 90%;\n  animation: modalSlideIn 0.2s ease-out;\n}\n\n.certificate-actions-bar {\n  display: flex;\n  gap: 6px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.cert-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  transition: all 0.2s ease;\n  color: #475569;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.cert-action-btn.add {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.cert-action-btn.add:hover {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.cert-action-btn.download-all {\n  width: auto;\n  padding: 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  gap: 6px;\n}\n\n.cert-action-btn.download-all:hover {\n  background: linear-gradient(135deg, #0020a7 0%, #4875e6 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n  color: white;\n}\n\n.cert-action-btn.download-all:active {\n  transform: translateY(0);\n}\n\n.cert-files-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.cert-file-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #f1f5f9;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #1e293b;\n  max-width: 160px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s;\n}\n\n.cert-file-tag:hover {\n  border-color: #cbd5e1;\n  background: #e2e8f0;\n}\n\n.cert-file-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.cert-file-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  padding: 0;\n  flex-shrink: 0;\n  transition: all 0.15s ease;\n  vertical-align: middle;\n}\n\n.cert-file-remove:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n\n.cert-upload-big {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 2px dashed #002FA7;\n  background: #f0f4ff;\n  color: #002FA7;\n  font-size: 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cert-upload-big:hover {\n  background: #002FA7;\n  color: white;\n  border-style: solid;\n}\n\n.certificate-cell {\n  min-width: 140px;\n}\n\n.certificate-fields {\n  margin-bottom: 4px;\n}\n\n/* Модальные окна */\n.reports-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  backdrop-filter: blur(4px);\n  z-index: 998;\n  animation: modalAppear 0.2s ease-out;\n}\n\n@keyframes modalAppear {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.reports-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 550px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  animation: modalSlideIn 0.2s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n.reports-modal.create-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.reports-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 12px 12px 0 0;\n  color: white;\n}\n\n.reports-modal-header-content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.reports-modal-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reports-modal-icon img {\n  width: 24px;\n  height: 24px;\n  filter: brightness(0) invert(1);\n}\n\n.reports-modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: white;\n}\n\n.reports-modal-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  opacity: 0.9;\n  color: white;\n}\n\n.reports-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: white;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.reports-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.reports-modal-content {\n  padding: 24px;\n  flex: 1;\n}\n\n.reports-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 24px;\n  border-top: 1px solid #f3f4f6;\n  background: white;\n  border-radius: 0 0 12px 12px;\n}\n\n/* Стили для модального окна со студентами */\n.students-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  border-radius: 16px;\n  width: 95%;\n  max-width: 1300px;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  z-index: 999;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  animation: modalSlideIn 0.2s ease-out;\n}\n\n.students-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border-radius: 16px 16px 0 0;\n  flex-shrink: 0;\n}\n\n.students-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.students-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.students-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.students-modal-table-wrapper {\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n/* Таблица студентов - без горизонтального скролла */\n.students-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  table-layout: fixed;\n}\n\n.students-table th {\n  background: #f8fafc;\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #002FA7;\n  border-bottom: 2px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  font-size: 12px;\n}\n\n.students-table td {\n  padding: 10px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  vertical-align: top;\n  word-break: break-word;\n}\n\n/* Ширина колонок */\n.disabled-table th:nth-child(1),\n.disabled-table td:nth-child(1) { width: 40px; text-align: center; }\n.disabled-table th:nth-child(2) { width: 12%; }\n.disabled-table th:nth-child(3) { width: 7%; }\n.disabled-table th:nth-child(4) { width: 15%; }\n.disabled-table th:nth-child(5) { width: 18%; }\n.disabled-table th:nth-child(6) { width: 10%; }\n.disabled-table th:nth-child(7) { width: 10%; }\n.disabled-table th:nth-child(8) { width: 8%; }\n.disabled-table th:nth-child(9) { width: 12%; }\n.disabled-table th:nth-child(10) { width: 8%; }\n\n.orphan-table th:nth-child(1),\n.orphan-table td:nth-child(1) { width: 40px; text-align: center; }\n.orphan-table th:nth-child(2) { width: 10%; }\n.orphan-table th:nth-child(3) { width: 6%; }\n.orphan-table th:nth-child(4) { width: 12%; }\n.orphan-table th:nth-child(5) { width: 7%; }\n.orphan-table th:nth-child(6) { width: 12%; }\n.orphan-table th:nth-child(7) { width: 12%; }\n.orphan-table th:nth-child(8) { width: 15%; }\n.orphan-table th:nth-child(9) { width: 12%; }\n.orphan-table th:nth-child(10) { width: 8%; }\n\n.students-table tbody tr:hover {\n  background-color: #f8fafc;\n}\n\n.col-num {\n  text-align: center;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Редактируемые ячейки */\n.cell-content {\n  cursor: pointer;\n  padding: 4px 4px;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n}\n\n.cell-content:hover {\n  background-color: #e0e8ff;\n}\n\n.edit-input {\n  width: 100%;\n  padding: 6px 8px;\n  border: 2px solid #002FA7;\n  border-radius: 6px;\n  font-size: 12px;\n  background: white;\n  box-sizing: border-box;\n}\n\n.edit-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.certificate-textarea {\n  resize: none;\n  min-height: 40px;\n  font-family: inherit;\n}\n\n.certificate-input-small {\n  width: 80px;\n  padding: 2px 4px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 11px;\n  margin: 2px 0;\n}\n\n.certificate-image-section {\n  margin-top: 6px;\n}\n\n.certificate-upload-btn {\n  padding: 4px 8px;\n  background: #f0f4ff;\n  border: 1px dashed #002FA7;\n  border-radius: 6px;\n  color: #002FA7;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n.certificate-upload-btn:hover {\n  background: #e0e8ff;\n}\n\n.certificate-preview {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.certificate-thumb {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n}\n\n.certificate-change-btn {\n  padding: 3px 8px;\n  background: #f1f5f9;\n  border: none;\n  border-radius: 4px;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n/* Формы */\n.pc-form-group {\n  margin-bottom: 20px;\n}\n\n.pc-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 14px;\n}\n\n.pc-input-enhanced {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  background: white;\n  box-sizing: border-box;\n}\n\n.pc-input-enhanced:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 4px rgba(0, 47, 167, 0.1);\n}\n\n.reports-format-static {\n  margin-top: 8px;\n}\n\n.reports-format-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 10px 20px;\n  background: #f1f5f9;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n}\n\n/* Кнопки */\n.reports-btn-secondary {\n  padding: 12px 24px;\n  background: white;\n  color: #374151;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.reports-btn-secondary:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n  background: #f8fafc;\n}\n\n.cell-stack { \n  display: flex; \n  flex-direction: \n  column; gap: \n  4px; \n\n}\n\n.cell-line  { \n  color: #1e293b; \n\n}\n\n.cell-phone { \n  color: #475569; \n  font-size: 13px; \n}\n\n.reports-confirm-btn {\n  padding: 12px 32px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 140px;\n}\n\n.reports-confirm-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.reports-confirm-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Инфо иконка */\n.info-icon-btn {\n  position: relative;\n  display: inline-block;\n}\n\n.header-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n}\n\n.pc-refresh-btn {\n  gap: 8px;\n}\n\n.pc-refresh-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.info-tooltip {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  width: 320px;\n  z-index: 100;\n  display: none;\n}\n\n.info-icon-btn:hover .info-tooltip {\n  display: block;\n}\n\n/* Адаптивность */\n@media (max-width: 1024px) {\n  .reports-quick-create.two-columns {\n    grid-template-columns: 1fr;\n  }\n  \n  .reports-stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .reports-stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .reports-modal {\n    width: 95%;\n  }\n  \n  .students-modal {\n    width: 98%;\n    max-height: 90vh;\n  }\n  \n  .students-modal-header h3 {\n    font-size: 14px;\n  }\n  \n  .students-table {\n    font-size: 11px;\n  }\n  \n  .students-table th,\n  .students-table td {\n    padding: 6px;\n  }\n}\n\n/* Модальное окно широкое */\n.students-modal.wide-modal {\n  width: 98%;\n  max-width: 1600px;\n}\n\n/* Поиск в модальном окне */\n.modal-search-box {\n  position: relative;\n  margin: 16px 24px 0 24px;\n}\n\n.modal-search-input {\n  width: 100%;\n  padding: 12px 20px 12px 44px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  background: white;\n  box-sizing: border-box;\n}\n\n.modal-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.modal-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n}\n\n.modal-search-clear {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 4px 6px;\n  border-radius: 20px;\n}\n\n.modal-search-clear:hover {\n  background: #f1f5f9;\n  color: #002FA7;\n}\n\n/* Ширина колонок - узкий номер */\n.disabled-table .col-num-header,\n.orphan-table .col-num-header {\n  width: 45px;\n  text-align: center;\n}\n\n.disabled-table td.col-num,\n.orphan-table td.col-num {\n  width: 45px;\n  text-align: center;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Поле для справки - полная ширина */\n.certificate-fields .edit-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 12px;\n  background: white;\n  box-sizing: border-box;\n}\n\n.certificate-fields .edit-input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* Превью фото справки */\n.certificate-thumb {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.certificate-thumb:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Пустая строка в таблице */\n.empty-row {\n  text-align: center;\n  padding: 40px !important;\n  color: #64748b;\n}\n\n/* Упрощенная секция отчетов */\n.recent-reports-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.recent-reports-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.reports-count {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.reports-count strong {\n  color: #002FA7;\n}\n\n/* Адаптация */\n@media (max-width: 1200px) {\n  .students-table {\n    min-width: 1000px;\n  }\n}\n\n@media (max-width: 768px) {\n  .students-modal.wide-modal {\n    width: 98%;\n  }\n  \n  .modal-search-box {\n    margin: 12px 16px 0 16px;\n  }\n  \n  .certificate-fields .edit-input {\n    font-size: 10px;\n    padding: 6px 8px;\n  }\n  \n  .image-preview-modal {\n    width: 95%;\n    padding: 12px;\n  }\n}\n\n.reports-actions-cell {\n  white-space: nowrap;\n  width: 1%;\n}\n\n.disabled-table th:nth-child(10), \n.disabled-table td:nth-child(10) { \n  width: 10%; \n  min-width: 140px; \n}\n\n.orphan-table th:nth-child(10),\n.orphan-table td:nth-child(10) { \n  width: 10%; \n  min-width: 140px; \n}\n\n/* Стили для валидации */\n.edit-input.validation-error {\n  border-color: rgb(102, 60, 25);\n  background-color: #fef2f2;\n}\n\n.edit-input.validation-error:focus {\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n  border-color: #b88441;\n}\n\n.validation-error-message {\n  font-size: 11px;\n  color: #b88441;\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.validation-error-message::before {\n  content: '⚠';\n  font-size: 10px;\n}\n\n.loading-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #64748b;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.loading-overlay::before {\n  content: '';\n  width: 24px;\n  height: 24px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #002FA7;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-right: 12px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Анимация обновления */\n.pc-refreshing {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.pc-refresh-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Стили для загрузки сертификата */\n.certificate-upload-btn {\n  padding: 6px 12px;\n  background: #f0f4ff;\n  border: 1px dashed #002FA7;\n  border-radius: 8px;\n  color: #002FA7;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.certificate-upload-btn:hover {\n  background: #e0e8ff;\n  border-style: solid;\n}\n\n.certificate-change-btn {\n  padding: 4px 10px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #475569;\n  transition: all 0.2s ease;\n}\n\n.certificate-change-btn:hover {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.certificate-preview {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.certificate-thumb {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.certificate-thumb:hover {\n  transform: scale(1.05);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Улучшенные стили для редактируемых ячеек */\n.cell-content {\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: all 0.15s ease;\n  min-height: 20px;\n  line-height: 1.4;\n}\n\n.cell-content:hover {\n  background-color: #e0e8ff;\n  color: #002FA7;\n}\n\n.cell-content:empty::before {\n  content: '—';\n  color: #94a3b8;\n}\n\n.edit-input {\n  width: 100%;\n  padding: 6px 10px;\n  border: 2px solid #002FA7;\n  border-radius: 6px;\n  font-size: 13px;\n  background: white;\n  box-sizing: border-box;\n  font-family: inherit;\n  line-height: 1.4;\n}\n\n.edit-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.certificate-textarea {\n  resize: vertical;\n  min-height: 60px;\n  font-family: inherit;\n}\n\n/* Стили для пустых состояний */\n.empty-row {\n  text-align: center;\n  padding: 40px !important;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* Адаптация модальных окон */\n@media (max-width: 768px) {\n  .students-modal.wide-modal {\n    width: 98%;\n    max-height: 90vh;\n  }\n\n  .students-modal-header h3 {\n    font-size: 14px;\n  }\n\n  .students-table {\n    font-size: 11px;\n  }\n\n  .students-table th,\n  .students-table td {\n    padding: 6px 4px;\n  }\n\n  .certificate-thumb {\n    width: 40px;\n    height: 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
